export const FREE_BOOKING_PROCESS_NAME = 'calligo-free-booking';
export const FREE_BOOKING_PROCESS_ALIAS = `${FREE_BOOKING_PROCESS_NAME}/release-4`;
